module.exports = __webpack_public_path__ + "img/bluesky12.e39085cb.jpg";